const STORAGE_PREFIX = 'descope.smsMfaEnabled'

function getStorageKey (email) {
  return `${STORAGE_PREFIX}.${String(email || '').trim().toLowerCase()}`
}

export function getSmsMfaPreference (email) {
  const storedValue = getLocal(getStorageKey(email))

  if (storedValue === null) return null

  return storedValue === 'true'
}

export function setSmsMfaPreference (email, enabled) {
  if (!email) return
  setLocal(getStorageKey(email), String(enabled))
}

// Member Hub masks phone_number on the profile until *it* considers the number verified
// (e.g. "*******1234"), independent of Descope's own verification. A strict string
// equality against descope.phone (which always holds the real number) would then fail
// forever even right after a successful Descope verification, permanently hiding the
// "Verified" badge/toggle and re-prompting setup on every visit. Comparing just the
// trailing digits tolerates the mask while still catching an actually-different number.
export function isSamePhoneNumber (a, b) {
  const digitsA = String(a || '').replace(/\D/g, '')
  const digitsB = String(b || '').replace(/\D/g, '')
  if (!digitsA || !digitsB) return false

  const length = Math.min(4, digitsA.length, digitsB.length)
  return digitsA.slice(-length) === digitsB.slice(-length)
}